export { getServerSideProps } from 'views/learn/LearnBrand/getServerSideProps';

export { default } from 'views/learn/LearnBrand';
